import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { OrganizationAdminModel } from '../models/organizationAdmin.model';
import { OrganizationAdminService } from '../models/organizationAdmin.service';
import { PersonModel } from '../../person/models/person.model';
import { PersonService } from '../../person/models/person.service';
import { OrganizationModel } from '../../organization/models/organization.model';
import { OrganizationService } from '../../organization/models/organization.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, IKeyValueInterface } from '../../shared/config';

@Component({
  selector: 'wego-organizationadmin',
  template: require('../views/organizationAdmin-list.component.html'),
  providers: [OrganizationService, PersonService, OrganizationAdminService],

})
export class OrganizationAdminListComponent implements OnInit {

  DataListModel: DataListModel;
  sub: any;
  organizationMasterHashId: string;
  organizationAdminList: OrganizationAdminModel[];
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  isLoading: boolean;
  deleteOrganizationAdminMasterHashId: string;
  resetPasswordPersonHashId: string;
  message: string;
  errorMessage: string;
  organizationName: string;
  urlDefaultPage: string;
  urlOrganizationList: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  validateMessage: string;
  blockUnblockMsg: string;
  blockUnblockOrganizationAdminHashId: string;
  blockMsg: string;
  private popupMsg: string;
  private popupTitle: string;
  private module: string;
  private breadCrumbList: string;
  private organizationList: string;

  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('addOrganizationAdminModal') public addOrganizationAdminModal: any;
  @ViewChild('resetPasswordModal') public resetPasswordModal: any;
  @ViewChild('inActiveModal') public inActiveModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(private organizationAdminService: OrganizationAdminService,
    private personService: PersonService,
    private organizationService: OrganizationService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService) {
  }

  get isAnyChecked(): boolean {
    if (this.organizationAdminList) {
      let isCheck = this.organizationAdminList.filter(x => x.isUserOrganizationAdmin == false).some(x => x.isChecked == true);
      if (isCheck) {
        if (this.organizationAdminList.filter(x => x.isUserOrganizationAdmin == false).every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  ngOnInit() {
    this.module = this.translate.instant('LblOrganizationAdmin');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.organizationList = this.translate.instant('LblListPage', [this.translate.instant('LblOrganization')]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlOrganizationList = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_LIST);
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.organizationMasterHashId = params['organizationHashId'] || '';
        if (this.organizationMasterHashId != '') {
          this.GetOrganizationAdminList();
          this.GetOrganizationDetailsByCompanyId(this.organizationMasterHashId);
        }
      });
  }

  public GetOrganizationDetailsByCompanyId(organizationMasterHashId: string) {
    this.organizationService.GetOrganizationBasicDetail(organizationMasterHashId)
      .subscribe(
      res => {
        this.organizationName = res.data.entityName;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetOrganizationAdminList() {
    this.isLoading = true;
    this.organizationAdminService.GetOrganizationAdminList(this.organizationMasterHashId, this.DataListModel)
      .subscribe(
      res => {
        this.organizationAdminList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetOrganizationAdminList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetOrganizationAdminList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetOrganizationAdminList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetOrganizationAdminList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.organizationAdminService.ExportOrganizationAdminList(this.organizationMasterHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "OrganizationAdmin" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }

  public DeleteCompanyAdmin(deleteOrganizationAdminList: string[]) {
    this.isLoading = true;
    this.organizationAdminService.DeleteOrganizationAdmin(deleteOrganizationAdminList)
      .subscribe(
      res => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.GetOrganizationAdminList();
          this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = res.error;          
          this.ShowAlertPopup();       
          this.isLoading = false;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnParentCheck(isChecked: boolean) {
    this.organizationAdminList.filter(x => x.isUserOrganizationAdmin == false && x.canRemove).forEach(x => x.isChecked = isChecked);
  }

  public ShowAlertModal(deleteOrganizationAdminMasterHashId?: string): void {
    if (deleteOrganizationAdminMasterHashId) {
      this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deleteOrganizationAdminMasterHashId = deleteOrganizationAdminMasterHashId;
    }
    else {
      this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.deleteOrganizationAdminMasterHashId = "";
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    let deleteOrganizationAdminList: any[];
    if (this.isMultipleDelete)
      deleteOrganizationAdminList = this.organizationAdminList.filter(x => x.isChecked).map(x => x.organizationAdminHashId);
    else
      deleteOrganizationAdminList.push(this.deleteOrganizationAdminMasterHashId);

    this.DeleteCompanyAdmin(deleteOrganizationAdminList);
    this.alertModal.hide();
  }
  public ShowAddOrganizationAdminModal() {
    this.addOrganizationAdminModal.organizationMasterHashId = this.organizationMasterHashId;
    this.addOrganizationAdminModal.show();
  }

  public SuccessAddOrganizationAdminModal($event: any) {
    this.GetOrganizationAdminList();
    this.message = $event.SuccessMessage;
  }

  public ResetPersonPassword(personHashID: string) {
    this.personService.ResetPersonPassword(personHashID)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResetPasswordSuccess');
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblResetPasswordFailure');      
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }


  public ShowResetPasswordModal(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
    this.resetPasswordModal.show();
  }

  public HideResetPasswordModal(): void {
    this.resetPasswordPersonHashId = "";
    this.resetPasswordModal.hide();
  }

  public InActiveCompanyAdmin() {
    this.isLoading = true;
    this.organizationAdminService.InActiveOrganizationAdmin(this.blockUnblockOrganizationAdminHashId)
      .subscribe(
      res => {
        if (res.data) {
          this.inActiveModal.hide();
          this.DataListModel.currentPage = 1;
          this.GetOrganizationAdminList();
          this.popupMsg = this.translate.instant('LblRecordBlokUnBlockSuccess', [this.module, this.blockMsg]);
          this.ShowSuccessPopup();
        }
        else {
          this.isLoading = false;
          this.popupMsg = res.error;
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowInActiveModal(organizationAdminHashId: string, isActive: boolean): void {
    this.blockUnblockOrganizationAdminHashId = organizationAdminHashId;
    this.blockMsg = isActive ? this.translate.instant('LblInactive') : this.translate.instant('LblActive');
    let roleType = this.translate.instant('LblOrganizationAdmin');
    this.blockUnblockMsg = this.translate.instant('LblBlockUnblockConfirm', [this.blockMsg, roleType]);
    this.inActiveModal.show();
  }

  public HideInActiveModal(): void {
    this.inActiveModal.hide();
  }

  public SuccessInActiveModalClick(): void {
    this.InActiveCompanyAdmin();
    this.inActiveModal.hide();
  }

  public SuccessResetPasswordModalClick(): void {
    this.resetPasswordModal.hide();
    console.log(this.resetPasswordPersonHashId);
    this.ResetPersonPassword(this.resetPasswordPersonHashId);

  }

  public ShowAlertPopup(): void {
    this.popupTitle = this.translate.instant('LblWarning');
    this.successPopup.show();
  }

  public ShowSuccessPopup(): void {
    this.popupTitle = this.translate.instant('LblSuccess');
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();

  }
  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationadmin/components/organizationAdmin-list.component.ts